.list {
  margin-bottom: 2em;
}

.list > li + li {
  margin-top: 0.25em;
}
